var app = angular.module('leonardo');

var TaskGroup = function(PropertyService, AuthDataService, ConfigThemeService) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      scope.getOptions = function(type, taskGroup, trailing) {
        var options = {
          strokeWidth: 6,
          trailColor: ConfigThemeService.getColor('tertiaryColor', 0.2),
          color: ConfigThemeService.config.theme_config.errorColor
        };
        if (trailing){
          if (type !== 'total') {
            var value_trainig = taskGroup.trailing_progress.total_percent_expected;
            if ((taskGroup.pending === 0) && (taskGroup.total === 0))
              value_trainig = 0;
            if (value_trainig > AuthDataService.authData.account['progress_' + type.toLowerCase() + '_warning']) options['color'] = ConfigThemeService.config.theme_config.successColor;
            else if (value_trainig > AuthDataService.authData.account['progress_' + type.toLowerCase() + '_danger']) options['color'] = ConfigThemeService.config.theme_config.warningColor;
          }
          else {
            if (taskGroup.total === 0)
              options['color'] = ConfigThemeService.getColor('tertiaryColor', 0.2);
            else {
              var value_trainig1 = taskGroup.progress_status;
              if (value_trainig1 == PropertyService.PROGRESS_STATUS_OK) options['color'] = ConfigThemeService.config.theme_config.successColor;
              else if (value_trainig1 == PropertyService.PROGRESS_STATUS_WARNING) options['color'] = ConfigThemeService.config.theme_config.warningColor;
            }
          }
        }
        else {
          if (type !== 'total') {
            var value = taskGroup.percent_done;
            if ((taskGroup.pending === 0) && (taskGroup.total === 0))
              value = 0;
            if (value > AuthDataService.authData.account['progress_' + type.toLowerCase() + '_warning']) options['color'] = ConfigThemeService.config.theme_config.successColor;
            else if (value > AuthDataService.authData.account['progress_' + type.toLowerCase() + '_danger']) options['color'] = ConfigThemeService.config.theme_config.warningColor;
          }
          else {
            if (taskGroup.total === 0)
              options['color'] = ConfigThemeService.getColor('tertiaryColor', 0.2);
            else {
              var value1 = taskGroup.progress_status;
              if (value1 == PropertyService.PROGRESS_STATUS_OK) options['color'] = ConfigThemeService.config.theme_config.successColor;
              else if (value1 == PropertyService.PROGRESS_STATUS_WARNING) options['color'] = ConfigThemeService.config.theme_config.warningColor;
            }
          }
        }
        return options;
      };

      scope.getValue = function (taskGroup, trailing) {
        if (trailing) {
          var value_trainig = taskGroup.trailing_progress.total_percent_expected;
          if ((taskGroup.pending === 0) && (taskGroup.total === 0)) {
            value_trainig = 0;
          }
          return value_trainig / 100;
        }
        else {
          var value = taskGroup.percent_done;
          if ((taskGroup.pending === 0) && (taskGroup.total === 0)) {
            value = 0;
          }
          return value / 100;
        }
      };

      scope.getText = function (taskGroup, trailing) {
        if (trailing) {
          var value_trainig1 = taskGroup.trailing_progress.total_percent_expected + '%';
          if ((taskGroup.pending === 0) && (taskGroup.total === 0)) {
            value_trainig1 = 'N/A';
          }
          return value_trainig1;
        }
        else {
          var value = taskGroup.percent_done + '%';
          if ((taskGroup.pending === 0) && (taskGroup.total === 0)) {
            value = 'N/A';
          }
          return value;
        }
      };
    }
  };
};

app.directive('taskGroup', ['PropertyService', 'AuthDataService', 'ConfigThemeService', TaskGroup]);
